// src/pages/NotFound.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiHome, FiArrowLeft, FiAlertCircle } from 'react-icons/fi';
import { Button } from '../components/ui';

const NotFound = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleGoHome = () => {
        navigate('/');
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-2 dark:bg-boxdark-2 p-4">
            <div className="max-w-lg w-full text-center">
                <div className="space-y-8">
                    {/* 404 Header */}
                    <div className="space-y-4">
                        <h1 className="text-9xl font-black text-stroke/50 dark:text-strokedark">
                            404
                        </h1>
                        <h2 className="text-2xl font-bold text-black dark:text-white">
                            Page Not Found
                        </h2>
                        <p className="text-lg text-body max-w-sm mx-auto">
                            The page you're looking for doesn't exist or has been moved.
                        </p>
                    </div>

                    {/* URL Information */}
                    <div className="flex items-start gap-3 p-4 rounded-lg bg-primary/10 text-left">
                        <FiAlertCircle size={20} className="text-primary mt-0.5 flex-shrink-0" />
                        <div>
                            <h3 className="font-semibold text-black dark:text-white">
                                Requested URL
                            </h3>
                            <code className="text-sm text-primary bg-primary/10 px-2 py-0.5 rounded">
                                {location.pathname}{location.search}
                            </code>
                        </div>
                    </div>

                    <div className="border-t border-stroke dark:border-strokedark" />

                    {/* Navigation Options */}
                    <div className="space-y-4">
                        <p className="font-semibold text-black dark:text-white">
                            Where would you like to go?
                        </p>

                        <div className="flex flex-col items-center gap-3">
                            <Button
                                variant="primary"
                                size="lg"
                                icon={FiHome}
                                onClick={handleGoHome}
                                className="w-72"
                            >
                                Go to Dashboard
                            </Button>

                            <Button
                                variant="outline"
                                size="lg"
                                icon={FiArrowLeft}
                                onClick={handleGoBack}
                                className="w-72"
                            >
                                Go Back
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
